import { FILTER_CONFIG_NAMES } from './DataConstants';

export const getWalkthroughFilterConfig = ({
	filters,
	// The Site Survey filter is internal-only: it's shown to buyers and internal techs, and hidden
	// from third-party suppliers.
	showSiteSurveyFilter = false,
}: {
	filters: any;
	showSiteSurveyFilter?: boolean;
}) => {
	return [
		filters[FILTER_CONFIG_NAMES.LOCATION],
		showSiteSurveyFilter ? filters[FILTER_CONFIG_NAMES.SITE_SURVEY] : null,
		filters[FILTER_CONFIG_NAMES.NOTES_STATUS],
		filters[FILTER_CONFIG_NAMES.CREATED_AT],
		filters[FILTER_CONFIG_NAMES.COMPLETED_AT],
	].filter(Boolean);
};
